import { useEffect, useRef, useState } from "react"
import { ChevronDown, Store, Check, LoaderCircle, RefreshCw } from "lucide-react"
import { useDispatch, useSelector } from "react-redux"
import { changeActiveStore } from "../../api/products/post"
import { allStoresData, userData } from "../../store/actions"
// import { changeStore } from "../../store/actions"

type Props = {
    store: any
}

export default function StoreSelect({ store }: Props) {
    const { allstoresdata, allstoresloading, allstoreserror } = useSelector((state: any) => state.UserReducer)
    const stores = Array.isArray(allstoresdata) ? allstoresdata : []
    const dispatch = useDispatch()

    const [open, setOpen] = useState(false)
    const ref = useRef<HTMLDivElement>(null)

    /* Close on outside click */
    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setOpen(false)
            }
        }
        document.addEventListener("mousedown", handler)
        return () => document.removeEventListener("mousedown", handler)
    }, [])

    return (
        <div ref={ref} className="relative">
            {/* SELECT BUTTON */}
            <button
                type="button"
                aria-label="Changer de boutique"
                aria-expanded={open}
                aria-controls="topbar-store-menu"
                onClick={() => setOpen(v => !v)}
                className="
          flex items-center gap-3
          px-3 py-2
          rounded-xl
          bg-white
          border border-gray-200
          hover:border-gray-300
          transition
        "
            >
                <div className="h-9 w-9 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center">
                    <Store size={18} />
                </div>

                <div className="text-left hidden sm:block">
                    <p className="text-sm font-semibold text-gray-800 leading-tight">
                        {store?.name || "Sélectionner une boutique"}
                    </p>
                    <p className="text-xs text-gray-400">
                        Boutique active
                    </p>
                </div>

                <ChevronDown
                    size={18}
                    className={`text-gray-400 transition ${open ? "rotate-180" : ""}`}
                />
            </button>

            {/* DROPDOWN */}
            {open && (
                <div
                    id="topbar-store-menu"
                    className="
            absolute left-0 mt-2 w-72
            bg-white rounded-2xl
            shadow-xl border
            overflow-hidden z-50
            animate-fadeIn
          "
                >
                    <div className="px-4 py-2 text-xs text-gray-500 border-b">
                        Vos boutiques
                    </div>

                    <div className="max-h-72 overflow-y-auto">
                        {allstoresloading ? (
                            <p role="status" className="flex items-center gap-2 px-4 py-4 text-sm text-gray-500">
                                <LoaderCircle size={16} className="animate-spin" />
                                Chargement des boutiques…
                            </p>
                        ) : allstoreserror ? (
                            <div className="space-y-3 px-4 py-4">
                                <p role="alert" className="text-sm text-red-600">{allstoreserror}</p>
                                <button type="button" onClick={() => dispatch(allStoresData())} className="inline-flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-700">
                                    <RefreshCw size={14} /> Réessayer
                                </button>
                            </div>
                        ) : stores.length === 0 ? (
                            <p className="px-4 py-4 text-sm text-gray-500">Aucune boutique disponible.</p>
                        ) : stores.map((s: any) => {
                            const active = s._id === store?._id

                            return (
                                <button
                                    key={s._id}
                                    onClick={async () => {
                                        await changeActiveStore(s._id)
                                        dispatch(userData())
                                        setOpen(false)
                                    }}
                                    className={`
                    w-full flex items-center gap-3 px-4 py-3 text-sm
                    transition
                    ${active
                                            ? "bg-blue-50 text-blue-700"
                                            : "hover:bg-gray-50 text-gray-700"
                                        }
                  `}
                                >
                                    <div
                                        className={`
                      h-9 w-9 rounded-xl flex items-center justify-center
                      ${active ? "bg-blue-100 text-blue-600" : "bg-gray-100 text-gray-500"}
                    `}
                                    >
                                        <Store size={16} />
                                    </div>

                                    <div className="flex-1 text-left">
                                        <p className="font-medium">{s.name}</p>
                                        <p className="text-xs text-gray-400">{s.city}</p>
                                    </div>

                                    {active && <Check size={16} className="text-blue-600" />}
                                </button>
                            )
                        })}
                    </div>
                </div>
            )}
        </div>
    )
}
